import React from 'react';
import { Callout, Kbd, List, Only, P, Steps, Sub, Table, UI } from '../ui';

export const RemoteSupport: React.FC = () => (
  <>
    <P>
      원격지원은 PC에 문제가 생겼을 때 담당자가 내 PC 화면을 보고, 내가 따로 허용하면 마우스와 키보드를 대신 조작해
      해결하는 기능입니다. 담당자의 프로필에서 바로 요청하므로 접속 코드나 별도 프로그램이 필요 없습니다.
      <Only env="desktop" />
    </P>
    <Callout tone="info" title="화면을 내줄 수 있는 곳">
      <p>
        화면을 보여 주는 쪽(직원)은 <b>Windows PC 앱</b>이어야 합니다. 원격지원 요청도 PC 앱에서만 보낼 수 있고, 웹
        브라우저나 휴대폰으로 접속해 있으면 화면을 보여 줄 수 없습니다. 담당자는 PC 앱과 웹 어디서든 지원할 수 있습니다.
      </p>
    </Callout>

    <Sub anchor="remote-support-request">원격지원 요청하기</Sub>
    <Steps>
      <>
        담당자의 프로필을 엽니다(온라인 탭에서 이름 누르기, 대화방에서 사진 누르기). 담당자는 Super Admin과 관리자가
        지정한 원격지원 담당자이며, <b>담당자의 프로필에만</b> <UI>원격지원 요청</UI> 버튼이 보입니다.
      </>
      <>
        <UI>원격지원 요청</UI>을 누르면 화면 오른쪽 아래에 대기 카드가 뜹니다. 기다리는 동안 대화는 계속할 수 있고,
        <UI>요청 취소</UI>로 언제든 그만둘 수 있습니다.
      </>
      <>
        담당자가 수락하면 주 모니터 가운데에 <UI>원격지원 시작</UI> 확인창이 뜹니다. <UI>공유</UI>를 한 번 누르면 담당자가
        내 화면을 봅니다. 화면을 고를 필요는 없습니다 — <b>모니터가 여러 대면 모든 모니터가 함께 보입니다</b>.
      </>
      <>
        모든 모니터 가장자리에 <b>주황색 테두리</b>, 주 모니터 위쪽 가운데에 <b>원격지원 막대</b>가 나타납니다. 이 표시는
        원격지원이 끝날 때까지 사라지지 않습니다.
      </>
    </Steps>
    <List>
      <>담당자가 접속 중일 때만 요청할 수 있습니다. 담당자가 오프라인이면 버튼이 흐리게 보입니다.</>
      <>담당자가 60초 안에 수락하지 않으면 요청은 저절로 끝납니다. 무엇이 문제인지 1:1 대화로 먼저 알려 주면 더 빨리 도움을 받을 수 있습니다.</>
      <>같은 담당자에게는 10분에 3번까지 요청할 수 있고, 담당자가 거절하면 2분 뒤에 다시 요청할 수 있습니다.</>
      <>PC 기본 정보(운영체제·메모리·디스크 여유 공간·IP)가 담당자에게 함께 전달됩니다. 파일은 내가 허용한 것만 오가고, 대화 내용은 전달되지 않습니다.</>
    </List>

    <Sub>담당자가 먼저 원격지원을 시작했을 때</Sub>
    <P>
      담당자가 내 프로필에서 원격지원을 시작하면 주 모니터 가운데에 <UI>원격지원 요청</UI> 확인창이 뜹니다. 요청한
      <b> 담당자의 이름·부서</b>를 확인한 뒤 <UI>공유</UI>를 한 번 누르면 됩니다. INA-TALK 창 위쪽에도 요청한 담당자의
      사진과 이름이 함께 보입니다.
    </P>
    <List>
      <>
        확인창은 INA-TALK 화면과 별개인 Windows 창이라 <b>직원이 직접 눌러야만</b> 화면이 나갑니다(담당자나 다른
        프로그램이 대신 누를 수 없습니다).
      </>
      <>
        <UI>거절</UI>을 누르거나 60초 안에 답하지 않으면 원격지원은 시작되지 않고 아무 일도 일어나지 않습니다. INA-TALK
        창 위쪽 배너의 <UI>거절</UI>도 같습니다.
      </>
      <>PC와 노트북에 함께 로그인해 두었다면 양쪽에 확인창이 뜨고, 먼저 공유를 누른 기기의 화면이 공유됩니다.</>
    </List>

    <Sub anchor="remote-support-control">마우스·키보드 제어를 허용할 때</Sub>
    <P>
      화면을 보던 담당자가 직접 조작해야 하면 <b>제어 요청</b>을 보냅니다. 그러면 주 모니터 가운데에
      <UI>원격 제어 요청</UI> 창이 따로 뜹니다. 이 창은 INA-TALK 화면과 별개인 Windows 창이라, <b>직원이 직접 마우스로
      눌러야만</b> 허용됩니다(담당자가 원격으로 누를 수 없습니다).
    </P>
    <List>
      <>허용하면 테두리가 <b>빨간색</b>으로 바뀌고 막대에 &quot;제어하고 있습니다&quot;가 표시됩니다.</>
      <>제어는 <b>최대 30분</b>입니다. 시간이 지나거나 담당자의 입력이 90초 넘게 없으면 제어가 저절로 끝나고, 담당자가 다시 요청하면 한 번 더 묻습니다.</>
      <>제어가 끝나도 화면 보기는 계속됩니다. 화면 보기까지 끝내려면 아래의 종료 방법을 쓰세요.</>
    </List>

    <Sub anchor="remote-support-files">파일 주고받기</Sub>
    <P>
      원격지원 중에는 담당자가 설치 파일·패치를 내 PC로 보내거나, 내 PC의 로그·문서를 가져갈 수 있습니다. 마우스·키보드
      제어를 허용하지 않아도 쓸 수 있지만, <b>파일마다 내가 직접 허용해야</b> 합니다.
    </P>
    <Table
      head={['상황', '내가 할 일']}
      rows={[
        [
          '담당자가 파일을 보낼 때',
          <>
            INA-TALK 창이 앞으로 나오며 <UI>파일 받기</UI> 창에 파일 이름과 크기가 보입니다. <UI>받기</UI>를 누르면
            <b> 다운로드 폴더</b>에 저장되고, 다 받으면 <UI>폴더 열기</UI>로 바로 찾을 수 있습니다.
          </>,
        ],
        [
          '담당자가 파일을 요청할 때',
          <>
            <UI>파일 요청</UI> 창에서 <UI>파일 선택</UI>을 누르고 보낼 파일을 고릅니다. <b>고른 파일만</b> 담당자에게
            전송됩니다.
          </>,
        ],
      ]}
    />
    <List>
      <>받은 파일은 <b>저장만 하고 실행하지 않습니다</b>. 설치 파일은 직접 실행해야 하고, 인터넷에서 받은 파일처럼 Windows가 한 번 더 확인할 수 있습니다.</>
      <>60초 안에 답하지 않으면 거절한 것으로 봅니다. 주고받는 중에도 진행 카드의 <UI>취소</UI>로 언제든 멈출 수 있고, 받다 만 파일은 지워집니다.</>
      <>한 번에 20개, 파일당 2GB까지 주고받을 수 있습니다. 대화방 첨부에서 막히는 실행 파일(.exe·.msi 등)도 원격지원에서는 주고받을 수 있습니다.</>
      <>파일은 서버를 거치지 않고 담당자 PC와 바로 오갑니다. 주고받은 파일 수는 내 원격지원 기록에, 파일 이름과 크기는 감사 기록에 남습니다.</>
    </List>

    <Sub>원격지원 끝내기</Sub>
    <Table
      head={['방법', '동작']}
      rows={[
        ['화면 위 막대의 [제어 중지]', '마우스·키보드 제어만 되찾습니다. 화면 보기는 계속됩니다'],
        ['화면 위 막대의 [종료]', '원격지원을 끝냅니다'],
        ['트레이 아이콘 메뉴의 [원격지원 종료]', '원격지원을 끝냅니다'],
        [<><Kbd>Ctrl</Kbd> + <Kbd>Alt</Kbd> + <Kbd>Shift</Kbd> + <Kbd>Q</Kbd></>, '원격지원을 끝냅니다(키보드만으로 바로)'],
        ['INA-TALK 창 위쪽의 원격지원 배너', '[제어 중지]·[종료]가 막대와 같게 동작합니다'],
      ]}
    />
    <P>
      끝나면 담당자·총 시간·제어 시간이 담긴 요약이 뜹니다. 지난 기록은 <UI>프로필 설정</UI> → <UI>원격지원 기록</UI>에서
      언제든 다시 볼 수 있고, 담당자가 남긴 처리 메모도 함께 보입니다.
    </P>

    <Callout tone="warn" title="원격으로 할 수 없는 것">
      <p>
        관리자 확인 창(UAC)·잠금 화면·<Kbd>Ctrl</Kbd>+<Kbd>Alt</Kbd>+<Kbd>Del</Kbd> 화면은 담당자에게 보이지도 눌리지도
        않습니다. 담당자가 부탁하면 직원이 직접 눌러 주세요. PC를 다시 시작하면 원격지원도 끝나므로 다시 요청해야 합니다.
      </p>
    </Callout>

    <Sub>담당자용: 원격지원 하기</Sub>
    <P>
      <b>Super Admin</b>과 관리자가 <b>원격지원 담당자</b>로 지정한 사람이 담당자입니다. 지정은 관리자 콘솔의 원격지원
      탭에서 합니다. 원격지원은 두 가지 방법으로 시작합니다.
    </P>
    <List>
      <>
        <b>직원의 요청을 받을 때</b> — 화면 오른쪽 위에 <UI>원격지원 요청</UI> 카드가 뜹니다(PC 앱은 알림도 뜹니다).
        <UI>수락</UI>을 누르면 원격지원 창이 열리고, 직원이 화면 공유를 누르기를 기다립니다. PC 앱과 웹에 함께 로그인해
        두었다면 먼저 수락한 곳에서 지원합니다.
      </>
      <>
        <b>직접 시작할 때</b> — 직원의 프로필을 열고 <UI>원격지원 시작</UI>을 누르면 원격지원 창이 열립니다. 직원 PC에
        확인창이 뜨고, 직원이 공유를 누르면 시작됩니다. 상대가 접속 중일 때만 누를 수 있고, 상대가 PC 앱에 접속해
        있지 않으면 안내가 뜹니다.
      </>
    </List>
    <Steps>
      <>
        <b>원격지원 창은 INA-TALK와 따로 뜨는 창</b>입니다. 직원이 공유를 누르면 이 창에 직원 PC의 모든 모니터가 한
        화면으로 나타납니다. 크기를
        바꾸거나 다른 모니터로 옮길 수 있고(다음에 열 때 그 자리에 뜹니다), 그동안 INA-TALK에서는 대화를 계속할 수
        있습니다. INA-TALK 오른쪽 아래의 원격지원 카드에서 <UI>창 보기</UI>를 누르면 원격지원 창으로 돌아갑니다.
      </>
      <>
        조작이 필요하면 <UI>제어 요청</UI>을 누르고 직원이 허용하기를 기다립니다. 허용되면 화면을 클릭해 조작하고, 키보드
        입력도 그대로 전달됩니다.
      </>
    </Steps>
    <Table
      head={['도구', '설명']}
      rows={[
        ['특수 키', 'Windows 키·Win+R(실행)·Alt+Tab처럼 담당자 PC에서 누르면 담당자 PC에서 동작해 버리는 조합을 직원 PC로 보냅니다'],
        ['텍스트 보내기', '긴 경로·주소를 직원 PC의 커서 위치에 그대로 입력합니다(500자까지)'],
        ['PC 정보', '운영체제·CPU·메모리·디스크·IP·모니터 구성을 봅니다'],
        [
          '파일',
          '파일 보내기(직원 PC 다운로드 폴더로)·파일 가져오기(직원이 고른 파일을 받음)·주고받은 파일 목록. 파일마다 직원이 허용합니다. 받은 파일은 PC 앱이면 내 다운로드 폴더에, 웹이면 브라우저 다운로드로 저장됩니다',
        ],
        ['대화 열기', '직원과의 1:1 대화방을 INA-TALK에서 엽니다. 원격지원 창은 그대로 있습니다'],
        [
          '전체 / 화면 1 · 화면 2',
          '직원 PC에 모니터가 여러 대일 때 보입니다. 전체는 모든 모니터를 한 화면에, 화면 1·2는 그 모니터 하나만 크게 보여 줍니다(화면 1이 왼쪽). 확대한 채로 클릭·조작해도 됩니다',
        ],
        ['원본 크기 / 화면 맞춤', '글자가 작으면 원본 크기로 보고 스크롤합니다'],
        ['제어 반납', '조작을 마치고 화면 보기만 남깁니다'],
      ]}
    />
    <List>
      <>Alt+F4·PrintScreen·Win+L은 보내지 않습니다(INA-TALK가 닫히거나 직원 화면이 잠기는 것을 막습니다).</>
      <>
        원격지원 창의 닫기(×)를 누르면 끝낼지 한 번 묻습니다. 끝나면 같은 창에 요약과 처리 메모 칸이 뜹니다 — 처리 메모를
        남겨 주세요. 직원도 자신의 원격지원 기록에서 메모를 볼 수 있습니다.
      </>
      <>원격지원 창은 INA-TALK를 거쳐 연결됩니다. INA-TALK를 새로 고치거나 로그아웃하면 원격지원도 끝납니다(INA-TALK 창을 닫아 트레이로 숨기는 것은 괜찮습니다).</>
      <>웹 브라우저에서는 이 사이트의 <b>팝업을 허용</b>해야 원격지원 창이 열립니다. 막혀 있으면 안내가 뜨고 요청은 보내지 않습니다.</>
      <>같은 직원에게는 10분에 3번까지 시작할 수 있고, 직원이 거절하면 2분 뒤에 다시 시작할 수 있습니다.</>
    </List>
    <Callout tone="tip" title="연결이 안 될 때">
      <p>
        회사 밖(재택·외부망)에 있는 PC와는 연결되지 않을 수 있습니다. 화면이 계속 &quot;연결하는 중&quot;이면 종료한 뒤 같은
        사내망에서 다시 시도해 주세요.
      </p>
    </Callout>
  </>
);
